import { setTitle, getTitle } from '@/utils/helper'

export default {
  state: {
    title: '',
    history: []
  },
  mutations: {
    setTitle(state, title) {
      state.title = getTitle(title)
      setTitle(title)
    },
    setHistory(state, history) {
      state.history.push(history)
    }
  }
}
